import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ConfirmationOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const queryParams = new URLSearchParams(location.search);
  const productsQuery = queryParams.get('products');
  const priceQuery = queryParams.get('price');
  const filteredProducts = productsQuery ? JSON.parse(decodeURIComponent(productsQuery)) : [];
  const totalPrice = priceQuery ? decodeURIComponent(priceQuery) : 0;
  
  const [customerDetails, setCustomerDetails] = useState({
    name: '',
    email: '',
    number: '',
    address: '',
  });

  const [errorMessage, setErrorMessage] = useState(''); // Track error messages

  // Handle customer input
  const handleInputChange = (e) => {
    setCustomerDetails({
      ...customerDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitOrder = async () => {
    if (filteredProducts.length === 0 || totalPrice === 0) {
      alert("Your cart is empty!");
      return;
    }

    // Validate customer details
    if (!customerDetails.name || !customerDetails.email || !customerDetails.number || !customerDetails.address) {
      setErrorMessage('Please fill all required fields.');
      return;
    }

    if (!customerDetails.email.includes('@gmail.com')) {
      setErrorMessage('Please enter a valid Gmail address.');
      return;
    }

    if (customerDetails.number.length !== 9) {
      setErrorMessage('Please enter a valid phone number (9 digits). 044 123 456');
      return;
    }

    if (customerDetails.address.length < 10) {
      setErrorMessage('Address must be at least 10 characters long.');
      return;
    }

    // Prepare the order details
    const orderDetails = {
      customer: customerDetails,
      items: filteredProducts.map(product => ({
        productId: product._id,
        name: product.name,
        price: product.price,
        quantity: product.quantity,
      })),
      total: totalPrice,
    };

    try {
      // Send the order details to the backend
      const response = await axios.post('https://cottonlocalhost1365.onrender.com/api/orders', orderDetails);
      console.log('Order submitted successfully:', response.data);

      // Show a success message
      alert('Thank You For Your Order!');

      // Navigate to the home page and reload
      navigate('/');
      window.location.reload(false);
    } catch (error) {
      console.error("Error submitting the order:", error);

      // Show an error message
      if (error.response) {
        setErrorMessage(error.response.data.message || 'Failed to submit order.');
      } else {
        setErrorMessage('There was an error submitting your order. Please try again.');
      }
    }
  };

  return (
    <div className="flex flex-col min-h-screen opacity-0 animate-fade-in mt-9"
      style={{ animationDelay: `${3 * 0.1}s` }}>
      <h1 className="text-2xl font-bold mb-4 text-[#212529]">Order Confirmation</h1>
      <div className="flex lg:flex-row-reverse md:flex-row-reverse flex-col sm:flex-row-reverse justify-center">
        <div className="text-white lg:ml-9 md:ml-9 sm:ml-9 p-4 bg-slate-500 rounded-xl min-w-[240px] min-h-[240px] mt-5">
          <h3 className="text-xl font-bold mb-2 text-orange-300">Selected Items</h3>
          {filteredProducts.length > 0 ? (
            filteredProducts.map((item, index) => (
              <div key={index} className="mb-4">
                <p className="font-mono text-orange-300">Item Name: {item.description}</p>
                <p className="font-mono text-orange-400">Price: {item.price} €</p>
                <p className="font-mono">Quantity: {item.quantity}</p>
                <br></br>
                <p className="font-mono text-black">* Price excludes shipping costs</p>
                <p className="font-mono text-sm">
                  Shipping rates: 
                  <span className="block">• Kosovo: 2 €</span>
                  <span className="block">• Albania & North Macedonia: 5 €</span>
                </p>
              </div>
            ))
          ) : (
            <p>Your Cart Is Empty</p>
          )}

          <h4 className="text-lg font-bold mt-4 text-white">Total Price: {totalPrice} €</h4>
        </div>
        <form className="flex flex-col space-y-4 p-4 m-2">
          <div className='flex flex-col items-center bg-indigo-400 space-y-4 rounded-lg w-[240px] min-h-[240px] p-2'>
            <input
              type="text"
              name="name"
              placeholder="Name Surname*"
              value={customerDetails.name}
              onChange={handleInputChange}
              className="rounded-xl mt-3 p-1"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={customerDetails.email}
              onChange={handleInputChange}
              className="rounded-xl p-1"
              required
            />
            <input
              type="number"
              name="number"
              placeholder="Phone Number*"
              value={customerDetails.number}
              onChange={handleInputChange}
              className="rounded-xl p-1 text-pretty"
              required
            />
            <textarea
              name="address"
              placeholder="Address*"
              value={customerDetails.address}
              onChange={handleInputChange}
              className="max-w-[200px] max-h-[100px] rounded-xl p-2 mt-16"
              required
            />
          </div>
          {errorMessage && (
            <p className="text-red-500 text-sm text-center">{errorMessage}</p>
          )}
          <button
            type="button"
            onClick={handleSubmitOrder}
            className="bg-blue-500 text-white p-2 rounded-xl"
          >
            Submit Order
          </button>
        </form>
      </div>
    </div>
  );
};

export default ConfirmationOrder;